/* ============================================================================
   Premium Gaveindpakning – Upsell popup
   Amante Copenhagen · Motion theme
   ----------------------------------------------------------------------------
   - Opfanger ALLE add-to-cart kald (fetch + XHR til /cart/add) – dækker tema-
     formularer, quick-add og alle custom personaliserings-snippets.
   - Viser en elegant popup oven på kurv-drawer med tilbud om gaveindpakning.
   - Ekskluderer gaveindpaknings-produktet selv + valgfri ID/tag-liste.
   - Tilføjer via /cart/add.js og opdaterer drawer uden reload.
   - Tracking: GA4 (dataLayer/gtag) + Shopify (line item property på ordren).
   ============================================================================ */
(function () {
  'use strict';

  // Idempotens-vagt: kør kun én gang, også hvis sektionen skulle blive
  // renderet mere end én gang (ingen dobbelt-binding / dobbelt fetch-wrap).
  if (window.__amanteGiftWrapInit) return;
  window.__amanteGiftWrapInit = true;

  var configEl = document.querySelector('[data-gift-wrap-config]');
  var overlay = document.querySelector('[data-gw-overlay]');
  if (!configEl || !overlay) return;

  var CONFIG;
  try {
    CONFIG = JSON.parse(configEl.textContent);
  } catch (e) {
    return;
  }
  if (!CONFIG.enabled || !CONFIG.variantId) return;

  /* ----------------------------------------------------------------------
     Routes (locale-sikre via Shopify.routes.root)
  ---------------------------------------------------------------------- */
  var ROOT = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var ADD_URL = ROOT + 'cart/add.js';
  var CART_URL = ROOT + 'cart.js';
  var productJsUrl = function (handle) { return ROOT + 'products/' + handle + '.js'; };

  /* ----------------------------------------------------------------------
     Eksklusionslister
  ---------------------------------------------------------------------- */
  function parseList(value) {
    if (!value) return [];
    return String(value)
      .split(',')
      .map(function (s) { return s.trim(); })
      .filter(Boolean);
  }

  // Gaveindpaknings-produktet ekskluderes ALTID (forhindrer popup-loop).
  var EXCLUDE_IDS = parseList(CONFIG.excludeProductIds).map(Number);
  EXCLUDE_IDS.push(Number(CONFIG.productId));

  var EXCLUDE_TAGS = parseList(CONFIG.excludeTags).map(function (t) {
    return t.toLowerCase();
  });

  var STORAGE_KEY = 'amante:giftwrap:lastShown';
  var SESSION_KEY = 'amante:giftwrap:dismissed';

  // Tag-cache så vi kun henter et produkts tags én gang.
  var tagCache = {};
  // Vagt så vores eget gaveindpaknings-add ikke trigger popup’en igen.
  var addingGiftWrap = false;

  /* ======================================================================
     1) FANG ADD-TO-CART (fetch + XHR)
  ====================================================================== */
  function isAddUrl(url) {
    return typeof url === 'string' && url.indexOf('/cart/add') !== -1;
  }

  // --- fetch ---
  var nativeFetch = window.fetch;
  if (typeof nativeFetch === 'function') {
    window.fetch = function () {
      var args = arguments;
      var url = args[0];
      if (url && typeof url === 'object' && url.url) url = url.url; // Request-objekt
      var promise = nativeFetch.apply(this, args);

      if (isAddUrl(url) && !addingGiftWrap) {
        promise
          .then(function (response) {
            if (!response || !response.ok) return;
            response
              .clone()
              .json()
              .then(handleAddedPayload)
              .catch(function () {});
          })
          .catch(function () {});
      }
      return promise;
    };
  }

  // --- XMLHttpRequest (dækker jQuery.ajax og evt. ældre paths) ---
  var XHR = window.XMLHttpRequest;
  if (XHR && XHR.prototype) {
    var nativeOpen = XHR.prototype.open;
    var nativeSend = XHR.prototype.send;

    XHR.prototype.open = function (method, url) {
      this.__gwIsAdd = isAddUrl(url);
      return nativeOpen.apply(this, arguments);
    };

    XHR.prototype.send = function () {
      if (this.__gwIsAdd && !addingGiftWrap) {
        this.addEventListener('load', function () {
          if (this.status < 200 || this.status >= 300) return;
          try {
            handleAddedPayload(JSON.parse(this.responseText));
          } catch (e) {}
        });
      }
      return nativeSend.apply(this, arguments);
    };
  }

  /* ======================================================================
     2) BESLUT OM POPUP SKAL VISES
  ====================================================================== */
  function handleAddedPayload(data) {
    if (!data) return;
    // /cart/add.js returnerer enten ét line item eller { items: [...] }.
    var items = data.items && data.items.length ? data.items : [data];

    // Find første item der IKKE er ekskluderet -> grund til at vise popup.
    eligibleAddedItem(items).then(function (item) {
      if (!item) return;
      if (!passesFrequency()) return;

      // "Ved hver tilføjelse": vis ALTID, også selv om der allerede ligger en
      // gaveæske i kurven – så kunden kan tilføje gaveindpakning pr. produkt.
      if (CONFIG.frequency === 'every') {
        window.setTimeout(openPopup, Number(CONFIG.showDelay) || 0);
        return;
      }

      // Ellers: vis ikke hvis gaveæsken allerede ligger i kurven.
      giftWrapInCart().then(function (inCart) {
        if (inCart) return;
        // Lille forsinkelse så popup glider ind oven på drawer.
        window.setTimeout(openPopup, Number(CONFIG.showDelay) || 0);
      });
    });
  }

  // Returnerer et promise med det første ikke-ekskluderede item (eller null).
  function eligibleAddedItem(items) {
    var idx = 0;
    function next() {
      if (idx >= items.length) return Promise.resolve(null);
      var item = items[idx++];
      return isExcluded(item).then(function (excluded) {
        return excluded ? next() : item;
      });
    }
    return next();
  }

  function isExcluded(item) {
    var pid = Number(item.product_id);
    if (EXCLUDE_IDS.indexOf(pid) !== -1) return Promise.resolve(true);
    if (!EXCLUDE_TAGS.length) return Promise.resolve(false);

    // Tags er ikke i add-svaret -> hent produkt-JSON (cachet).
    var handle = item.handle || item.url;
    if (!handle) return Promise.resolve(false);
    handle = String(handle).split('?')[0].split('/').pop();

    if (tagCache[handle]) {
      return Promise.resolve(hasExcludedTag(tagCache[handle]));
    }
    return fetch(productJsUrl(handle))
      .then(function (r) { return r.json(); })
      .then(function (p) {
        var tags = (p.tags || []).map(function (t) { return String(t).toLowerCase(); });
        tagCache[handle] = tags;
        return hasExcludedTag(tags);
      })
      .catch(function () { return false; });
  }

  function hasExcludedTag(tags) {
    for (var i = 0; i < EXCLUDE_TAGS.length; i++) {
      if (tags.indexOf(EXCLUDE_TAGS[i]) !== -1) return true;
    }
    return false;
  }

  function giftWrapInCart() {
    return fetch(CART_URL, { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        return (cart.items || []).some(function (i) {
          return Number(i.variant_id) === Number(CONFIG.variantId);
        });
      })
      .catch(function () { return false; });
  }

  /* ----------------------------------------------------------------------
     Frekvens-styring (session / cooldown / every)
  ---------------------------------------------------------------------- */
  function passesFrequency() {
    var freq = CONFIG.frequency || 'session';
    try {
      if (freq === 'session') {
        if (sessionStorage.getItem(SESSION_KEY)) return false;
      } else if (freq === 'cooldown') {
        var last = parseInt(localStorage.getItem(STORAGE_KEY), 10);
        var mins = Number(CONFIG.cooldownMinutes) || 60;
        if (last && Date.now() - last < mins * 60 * 1000) return false;
      }
    } catch (e) {}
    return true;
  }

  function markShownNow() {
    try {
      sessionStorage.setItem(SESSION_KEY, '1');
      localStorage.setItem(STORAGE_KEY, String(Date.now()));
    } catch (e) {}
  }

  /* ======================================================================
     3) POPUP UI
  ====================================================================== */
  var card = overlay.querySelector('[data-gw-card]');
  var addBtn = overlay.querySelector('[data-gw-add]');
  var addLabel = addBtn ? (addBtn.querySelector('[data-gw-add-label]') || addBtn) : null;
  var addLabelText = addLabel ? addLabel.textContent : '';
  var declineBtn = overlay.querySelector('[data-gw-decline]');
  var closeBtn = overlay.querySelector('[data-gw-close]');
  var lastFocused = null;
  var isOpen = false;

  function openPopup() {
    if (isOpen) return;
    isOpen = true;
    lastFocused = document.activeElement;

    overlay.hidden = false;
    // force reflow så transition kører
    overlay.offsetHeight; // eslint-disable-line no-unused-expressions
    overlay.classList.add('is-open');
    overlay.setAttribute('aria-hidden', 'false');

    markShownNow();
    track('shown');

    // Ikke-modal: vi stjæler IKKE fokus og spærrer ikke siden.
    document.addEventListener('keydown', onKeydown);
  }

  function closePopup(reason) {
    if (!isOpen) return;
    isOpen = false;

    overlay.classList.remove('is-open');
    overlay.setAttribute('aria-hidden', 'true');
    document.removeEventListener('keydown', onKeydown);

    window.setTimeout(function () {
      overlay.hidden = true;
      // nulstil knap til evt. næste visning
      if (addBtn) addBtn.disabled = false;
      if (addLabel) addLabel.textContent = addLabelText;
    }, 400);

    if (reason === 'decline' || reason === 'close') {
      // Brugeren afviste aktivt -> vis ikke igen i dette besøg.
      try { sessionStorage.setItem(SESSION_KEY, '1'); } catch (e) {}
    }
  }

  function onKeydown(e) {
    if (e.key === 'Escape' || e.keyCode === 27) {
      track('declined', { method: 'esc' });
      closePopup('close');
    }
  }

  function trapFocus(e) {
    var focusable = card.querySelectorAll(
      'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])'
    );
    if (!focusable.length) return;
    var first = focusable[0];
    var last = focusable[focusable.length - 1];
    if (e.shiftKey && document.activeElement === first) {
      e.preventDefault();
      last.focus();
    } else if (!e.shiftKey && document.activeElement === last) {
      e.preventDefault();
      first.focus();
    }
  }

  /* ----------------------------------------------------------------------
     Tilføj gaveindpakning til kurv
  ---------------------------------------------------------------------- */
  function addGiftWrap() {
    if (!addBtn || addBtn.disabled) return;
    addBtn.disabled = true;
    if (addLabel) addLabel.textContent = 'Tilføjer …';

    addingGiftWrap = true;
    fetch(ADD_URL, {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: JSON.stringify({
        // Ingen properties -> alle gaveæsker lægges sammen til ÉN linje i kurven.
        items: [{ id: CONFIG.variantId, quantity: 1 }]
      })
    })
      .then(function (r) { return r.json(); })
      .then(function (res) {
        addingGiftWrap = false;
        if (res && res.status && res.status !== 200) {
          // fx udsolgt
          addBtn.disabled = false;
          if (addLabel) addLabel.textContent = addLabelText;
          return;
        }
        track('accepted');
        refreshCartUI();

        if (addLabel) addLabel.textContent = CONFIG.successMessage || 'Tilføjet';
        window.setTimeout(function () { closePopup('accepted'); }, 1100);
      })
      .catch(function () {
        addingGiftWrap = false;
        addBtn.disabled = false;
        if (addLabel) addLabel.textContent = addLabelText;
      });
  }

  // Opdater kurv-drawer + free shipping bar uden reload (temaets egne events).
  function refreshCartUI() {
    document.dispatchEvent(new CustomEvent('cart:build'));
    fetch(CART_URL, { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: cart } }));
      })
      .catch(function () {});

    // Sørg for at drawer er åben så kunden ser tilføjelsen.
    document.dispatchEvent(new CustomEvent('cart:open'));
  }

  /* ======================================================================
     4) TRACKING (GA4 + custom event)
  ====================================================================== */
  function track(action, extra) {
    var payload = Object.assign(
      {
        event: 'gift_wrap_' + action, // shown | accepted | declined
        gift_wrap: {
          product_id: CONFIG.productId,
          variant_id: CONFIG.variantId,
          value: (Number(CONFIG.price) || 0) / 100,
          currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || 'DKK',
          location: 'cart-drawer'
        }
      },
      extra || {}
    );

    // GA4 via dataLayer + gtag
    if (CONFIG.trackGa4) {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push(payload);

      if (action === 'accepted' && typeof window.gtag === 'function') {
        // Standard GA4 ecommerce event for omsætnings-attribution.
        window.gtag('event', 'add_to_cart', {
          currency: payload.gift_wrap.currency,
          value: payload.gift_wrap.value,
          items: [
            {
              item_id: String(CONFIG.productId),
              item_name: CONFIG.productTitle,
              item_category: 'Gaveindpakning',
              price: payload.gift_wrap.value,
              quantity: 1
            }
          ]
        });
      }
    }

    // Generisk event så andre værktøjer kan lytte med.
    document.dispatchEvent(new CustomEvent('gift-wrap:' + action, { detail: payload }));
  }

  /* ======================================================================
     5) EVENT BINDINGS
  ====================================================================== */
  if (addBtn) addBtn.addEventListener('click', addGiftWrap);
  if (declineBtn) {
    declineBtn.addEventListener('click', function () {
      track('declined', { method: 'button' });
      closePopup('decline');
    });
  }
  if (closeBtn) {
    closeBtn.addEventListener('click', function () {
      track('declined', { method: 'close' });
      closePopup('close');
    });
  }

  // Klik inde i popup'en må IKKE boble ud til kurv-drawerens "luk ved klik udenfor".
  // (Motion lukker drawer ved ethvert klik uden for .drawer – popup'en ligger udenfor.)
  overlay.addEventListener('click', function (e) { e.stopPropagation(); });

  /* ----------------------------------------------------------------------
     Gaveindpaknings-modul i bunden af kurv-drawer (antal + Tilføj)
  ---------------------------------------------------------------------- */
  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t || !t.closest) return;
    var mod = t.closest('[data-gw-module]');
    if (!mod) return;
    var qtyEl = mod.querySelector('[data-gw-module-qty]');
    if (t.closest('[data-gw-module-minus]')) {
      if (qtyEl) qtyEl.value = Math.max(1, (parseInt(qtyEl.value, 10) || 1) - 1);
    } else if (t.closest('[data-gw-module-plus]')) {
      if (qtyEl) qtyEl.value = (parseInt(qtyEl.value, 10) || 1) + 1;
    } else if (t.closest('[data-gw-module-add]')) {
      e.preventDefault();
      moduleAdd(mod);
    }
  });

  function moduleAdd(mod) {
    if (addingGiftWrap) return;
    var variantId = mod.getAttribute('data-variant-id');
    var qtyEl = mod.querySelector('[data-gw-module-qty]');
    var btn = mod.querySelector('[data-gw-module-add]');
    var qty = Math.max(1, parseInt(qtyEl && qtyEl.value, 10) || 1);
    if (!variantId) return;
    if (btn) btn.disabled = true;
    addingGiftWrap = true;
    fetch(ADD_URL, {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ items: [{ id: variantId, quantity: qty }] })
    })
      .then(function (r) { return r.json(); })
      .then(function (res) {
        addingGiftWrap = false;
        if (btn) btn.disabled = false;
        if (res && res.status && res.status !== 200) return;
        track('accepted', { method: 'cart-module' });
        if (qtyEl) qtyEl.value = 1;
        refreshCartUI();
      })
      .catch(function () { addingGiftWrap = false; if (btn) btn.disabled = false; });
  }

  /* ----------------------------------------------------------------------
     "Fjern"-link på alle kurv-varer (event-delegation – kurven gen-renderes)
  ---------------------------------------------------------------------- */
  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t || !t.closest) return;
    var rem = t.closest('[data-gw-remove]');
    if (!rem) return;
    e.preventDefault();
    e.stopPropagation();
    var key = rem.getAttribute('data-key');
    if (!key || rem.dataset.busy) return;
    rem.dataset.busy = '1';
    rem.style.opacity = '0.4';
    fetch(ROOT + 'cart/change.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ id: key, quantity: 0 })
    })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        document.dispatchEvent(new CustomEvent('cart:build'));
        document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: cart } }));
      })
      .catch(function () { rem.dataset.busy = ''; rem.style.opacity = ''; });
  });

  /* ----------------------------------------------------------------------
     Theme editor: åbn/luk når sektionen vælges, så den kan styles.
  ---------------------------------------------------------------------- */
  if (CONFIG.designMode) {
    document.addEventListener('shopify:section:select', openPopup);
    document.addEventListener('shopify:section:deselect', function () { closePopup('editor'); });
  }
})();
